import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@sama/app-state';
import { ShapeState } from '../../../../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { TagService } from '../../../../../../../../outputs/annotation/annotation-shared/utils/tag.service';
import { ShapeSelectionService } from '../../../../utils/shape-selection.service';

@Component({
  selector: 'h3-edit-tags-button',
  templateUrl: './edit-tags-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./edit-tags-button.component.scss'],
  standalone: false,
})
/** @deprecated used for old projects without objects */
export class EditTagsButtonComponent {
  @Input({ required: true }) shapeStore!: Store<ShapeState>;

  constructor(
    private tagService: TagService,
    private selectionService: ShapeSelectionService,
  ) {}

  preventModifyingSelection(event: MouseEvent) {
    // this component handles selection differently than the shape list item
    event.preventDefault();
    event.stopPropagation();
  }

  showTagEditor(event: MouseEvent) {
    event.stopPropagation();
    const index = this.shapeStore.state().index;
    this.selectionService.setSelection([index]);
    this.tagService.openTagEditor(index, 'edit_tags_button');
  }
}
